import { createContext } from 'react';
export const DEFAULT_BACKGROUND_IMAGES = `url(${'images/landing-page-background-detailed.jpg'}), url(${'images/landing-page-background.jpg'})`;
export const LoginContext = createContext({
    forceOauthPrefix: false,
    includeClientSecret: false,
    imageList: DEFAULT_BACKGROUND_IMAGES,
    service: 'evo',
});
//# sourceMappingURL=LoginContext.js.map